import { useReveal } from "../../../../hooks/useReveal";
import styles from "./Features.module.css";

const features = [
  {
    icon: "✦",
    title: "Role-specific assessments",
    body: "Candidates take an assessment built for their role — 58 roles, each with its own test, including how they use AI at work. Filter your search to those who've completed it.",
  },
  {
    icon: "◆",
    title: "Anti-fake-candidate",
    body: "Our team reviews and approves every profile before employers can find it, and candidates take a role assessment before they can apply.",
  },
  {
    icon: "⬡",
    title: "Smart matching",
    body: "Tell us the role, the team, and the must-haves. Awasource ranks your shortlist automatically — and updates it as new candidates apply.",
  },
  {
    icon: "⚡",
    title: "Faster recruitment",
    body: "Cut your time-to-hire by 70%. Skip the resume pile and book interviews with the top matches from day one.",
  },
];

function FeatureCard({ icon, title, body }) {
  const { ref, isVisible } = useReveal();
  return (
    <div
      ref={ref}
      className={`${styles.card} ${isVisible ? styles.visible : styles.hidden}`}
    >
      <div className={styles.icon}>{icon}</div>
      <h3>{title}</h3>
      <p>{body}</p>
    </div>
  );
}

export default function Features() {
  return (
    <section className={styles.section} id="features">
      <div className={styles.container}>
        <div className={styles.sectionHead}>
          <span className={styles.eyebrow}>Features</span>
          <h2 className={styles.h2}>
            Everything you need to hire with confidence.
          </h2>
          <p className={styles.sub}>
            A complete hiring stack — built around verified data, not gut feel.
          </p>
        </div>

        <div className={styles.grid}>
          {features.map((f) => (
            <FeatureCard key={f.title} {...f} />
          ))}
        </div>
      </div>
    </section>
  );
}
